// Configuration file for environment-specific settings
// This ensures we always have fallback values if env vars are undefined

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://api.castlepos.com';
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';

// Log configuration on startup (only in development)
if (process.env.NODE_ENV === 'development') {
  console.log('[Config] BACKEND_URL:', BACKEND_URL);
  console.log('[Config] STRIPE_PUBLISHABLE_KEY:', STRIPE_PUBLISHABLE_KEY ? 'Set' : 'Not set');
}
